
<mce-page-with-navigation>

    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start"
                   [attr.test-id]="'site-admin-tabs'">

        
        <mat-tab>
            <ng-template mat-tab-label>
                <div class="flex items-center gap-2">
                    <mat-icon>dashboard</mat-icon>
                    Users
                </div>
            </ng-template>
            <div class="mt-4">
                <app-dashboard-admin></app-dashboard-admin>
            </div>
        </mat-tab>



        <mat-tab>
            <ng-template mat-tab-label>
                <div class="flex items-center gap-2">
                    <mat-icon>people</mat-icon>
                    Users
                </div>
            </ng-template>
            <div class="mt-4">
                <mce-support-user></mce-support-user>
            </div>
        </mat-tab>

        <mat-tab>
            <ng-template mat-tab-label>
                <div class="flex items-center gap-2">
                    <mat-icon>gavel</mat-icon>
                    Un-Used
                </div>
            </ng-template>
            <div class="mt-4">
                <p>reserved for future use</p>
            </div>
        </mat-tab>

        <mat-tab>
            <ng-template mat-tab-label>
                <div class="flex items-center gap-2">
                    <mat-icon>support</mat-icon>
                    Support
                </div>
            </ng-template>
            <div class="mt-4">
                <app-support></app-support>
            </div>
        </mat-tab>

        <mat-tab>
            <ng-template mat-tab-label>
                <div class="flex items-center gap-2">
                    <mat-icon>settings</mat-icon>
                    Site
                </div>
            </ng-template>
            <div class="mt-4">
                <mce-site></mce-site>
            </div>
        </mat-tab>

    </mat-tab-group>

</mce-page-with-navigation>
